import http from './public'

export default {
    // 获取轮播列表
    postList: (params) => {
        return http.fetchGet('postList', params)
    },
    // 获取中间导航
    naviList: (params) => {
        return http.fetchGet('naviList', params)
    },

    // 产品列表
    itemList: (params) => {
        return http.fetchGet('itemList', params)
    },
}